// Copyright (c) StrangeBee 2023

import { Route as InfosRoute } from './Infos';
import { Route as PasswordRoute } from './Password';
import { Route as APIRoute } from './APIKey';
import { Route as MFARoute } from './MFA';
import { Route as OptionsRoute } from './Options';

export default [InfosRoute, PasswordRoute, APIRoute, MFARoute, OptionsRoute];
